import { z } from 'zod';

import { ChainAvailabilityStatus } from '@/models/appointment/AppointmentChainAvailability.ts';

export const chainAvailabilityItemSchema = z.object({
    step_order: z.number().int().nonnegative(),
    appointment_type_id: z.string(),
    appointment_type_key: z.string(),
    calendar_id: z.string(),
    start_date: z.iso.datetime(),
    end_date: z.iso.datetime(),
    status: z.enum(ChainAvailabilityStatus),
});

export const chainAvailabilityResponseSchema = z.object({
    data: z.array(chainAvailabilityItemSchema),
});
